import React from "react";
import { btn3d } from "../styles/buttonStyles";

/* 상단 고정 헤더 — 로고(홈 복귀) + 언어/다크모드 토글 */
export default function AppHeader({ dm, lang, setLang, darkMode, setDarkMode, onLogo }) {
  return (
    <header className="app-header">
      <button
        onClick={onLogo}
        style={{
          display: "flex", alignItems: "center", gap: 7,
          background: "none", border: "none", padding: 0,
          cursor: "pointer", fontFamily: "inherit",
          WebkitTapHighlightColor: "transparent",
        }}
        aria-label="TripCanvas 홈"
      >
        <span style={{ fontSize: 20, lineHeight: 1 }}>✈️</span>
        <span
          className="text-md"
          style={{
            fontWeight: 900,
            letterSpacing: "-0.02em",
            backgroundImage: dm
              ? "linear-gradient(120deg,#A5B4FC,#C4B5FD)"
              : "linear-gradient(120deg,#4F46E5,#7C3AED)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          TripCanvas
        </span>
      </button>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {/* 언어 토글 */}
        <button
          onClick={() => setLang(lang === "ko" ? "en" : "ko")}
          className="btn3d text-xs"
          style={{
            ...btn3d("outline", dm),
            minHeight: 36, padding: "0 13px", borderRadius: 100,
            fontWeight: 800, letterSpacing: "0.06em",
          }}
          aria-label={lang === "ko" ? "Switch to English" : "한국어로 전환"}
        >
          {lang === "ko" ? "EN" : "KO"}
        </button>

        {/* 다크모드 토글 */}
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="btn3d"
          style={{
            ...btn3d("outline", dm),
            width: 36, height: 36, borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 15, padding: 0,
          }}
          aria-label={dm ? "라이트 모드로 전환" : "다크 모드로 전환"}
        >
          {dm ? "☀️" : "🌙"}
        </button>
      </div>
    </header>
  );
}
